import React from "react";
import { Link } from "react-router-dom";
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from "react-accessible-accordion";
import Divider from "../Components/Divider";
import CPanelComp from "../Components/Camparision/CpanelComp";
import CurrencyConverter from "../Components/CurrencyConverter";
import { useGeoLocation } from "../utils/useGeoLocation";
import { FaWifi, FaGlobe, FaThemeco } from "react-icons/fa";
import { BsDeviceSsdFill } from "react-icons/bs";
import { GrDomain } from "react-icons/gr";
import { MdEmail } from "react-icons/md";
import { BiSupport } from "react-icons/bi";
import EnhancedSEO from "../Components/EnhancedSEO";
import { 
  generateMetaTags, 
  pageConfigs, 
  generateServiceSchema,
  generateProductSchema,
  generateFAQSchema
} from "../utils/seoUtils";

function CpanelHosting() {
  const { 
    userLocation,
    userCurrency 
  } = useGeoLocation();

  // Pricing data for cPanel hosting plans (base prices in INR)
  const cpanelPlans = {
    clubstart: {
      name: "ClubStart",
      subtitle: "Ideal For Beginners",
      basePrice: 99,
      yearlyPrice: 999,
      features: [
        "Free Astra Pro & Divi Theme",
        "Host 1 Website",
        "10GB NVME SSD",
        "Unlimited Bandwidth",
        "Free SSL Certificate",
        "Europe Location"
      ],
      pid: "92",
      popular: false
    },
    clubpro: {
      name: "ClubPro", 
      subtitle: "Perfect For Professionals",
      basePrice: 149,
      yearlyPrice: 1499,
      features: [
        "Free Astra Pro & Divi Theme",
        "Host 10 Website",
        "50GB NVME SSD",
        "Unlimited Bandwidth",
        "Free SSL Certificate",
        "Europe Location"
      ],
      pid: "93",
      popular: true
    },
    clubelite: {
      name: "ClubElite",
      subtitle: "Optimized For Businesses", 
      basePrice: 199,
      yearlyPrice: 1999,
      features: [
        "1 Free Domain",
        "Free Astra Pro & Divi & Elementor Pro",
        "Host Unlimited Website",
        "100GB NVME SSD",
        "Unlimited Bandwidth",
        "Free SSL Certificate",
        "Europe Location",
      ],
      pid: "94",
      popular: false
    }
  };

  // Enhanced SEO configuration
  const cpanelPageConfig = generateMetaTags(pageConfigs.cpanelHosting);
  
  // Structured data for cPanel hosting page
  const cpanelStructuredData = [
    generateServiceSchema(
      "cPanel Web Hosting Services",
      "Professional cPanel web hosting services in India with easy website management, one-click installs, and 24/7 support."
    ),
    generateProductSchema(
      "cPanel Hosting Plan",
      "Affordable cPanel hosting with unlimited bandwidth, free SSL, and daily backups",
      "99"
    ),
    generateFAQSchema([
      {
        question: "What is cPanel hosting?",
        answer: "cPanel hosting is a web hosting service that includes the popular cPanel control panel, making it easy to manage your website, emails, databases, and files through a user-friendly interface."
      },
      {
        question: "Is cPanel hosting suitable for beginners?",
        answer: "Yes, cPanel hosting is perfect for beginners as it provides an intuitive graphical interface to manage all aspects of web hosting without requiring technical knowledge."
      },
      {
        question: "Do you provide free cPanel license?",
        answer: "Yes, the cPanel license is included free with all our cPanel hosting plans. You don't need to pay any additional fees for the control panel."
      }
    ])
  ];

  document.title = "";
  return (
    <>
      <EnhancedSEO 
        pageConfig={cpanelPageConfig}
        structuredData={cpanelStructuredData}
      />
      {/* ======= Hero Section ======= */}
      <section
        id="top"
        class="sharedtop bgcpanelhostingimg"
        style={{ color: "black" }}
      >
        <div class="container">
          <div class="row align-items-center">
            <div class="col-lg-7 col-12 topseccont">
              <div class="container">
                <span className="sa-bluebg-subhead">
                  👋 Up to 30% off Cpanel Hosting
                </span>
                <h1 className="sa-hero-h1 ">
                  Go Live with Affordable cPanel Hosting
                </h1>
                <h1 className="sa-hero-h3">In The Next 60 Seconds</h1>
                <p>
                  Every function at your fingertip with the best cPanel hosting.
                </p>
                <p>
                  Get the most intuitive Control Panel that every professional
                  wants.
                </p>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginBottom: "10px",
                  }}
                >
                  <img
                    src="/assets/img/list-arrow.svg"
                    alt="Check mark"
                    style={{
                      transform: "rotate(90deg)",
                      margin: "0 0.7rem 0 0",
                    }}
                  ></img>{" "}
                  <span>Simplicity</span>
                </div>

                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginBottom: "10px",
                  }}
                >
                  <img
                    src="/assets/img/list-arrow.svg"
                    alt="Check mark"
                    style={{
                      transform: "rotate(90deg)",
                      margin: "0 0.7rem 0 0",
                    }}
                  ></img>{" "}
                  <span>Flexibility </span>
                </div>

                <div style={{ display: "flex", alignItems: "center" }}>
                  <img
                    src="/assets/img/list-arrow.svg"
                    alt="Check mark"
                    style={{
                      transform: "rotate(90deg)",
                      margin: "0 0.7rem 0 0",
                    }}
                  ></img>{" "}
                  <span>Publish with Ease</span>
                </div>
                <br />
                {/* <ul class="topseclist">
                  <li>
                    <i class="fa fa-check-square-o" aria-hidden="true"></i>
                    Simplicity
                  </li>
                  <li>
                    <i class="fa fa-check-square-o" aria-hidden="true"></i>
                    Flexibility
                  </li>
                  <li>
                    <i class="fa fa-check-square-o" aria-hidden="true"></i>
                    Publish with Ease
                  </li>
                </ul> */}
                {/* <p class="topsecstrt">
                  Starts at <span>Rs.69/mo</span>
                </p> */}
                <a href="#pricing" className="btn btn-primary">
                  View Plans
                </a>
              </div>
            </div>
            <div class="col-lg-5 d-none d-lg-block">
              <img
                // src="../assets/img/cpanel-1.png"
                src="https://res.cloudinary.com/clubhosty/image/upload/v1752887473/generated-image_osqwrc.png"
                alt="imges"
                class="img-fluid bounce-img cpanel-hero-img"
              />
            </div>
          </div>
        </div>
      </section>

      {/* End Hero  */}

      <main id="main">
        {/* ======= Pricing Section =======  */}
        <section id="pricing" class="pricing section-bg">
          <div class="container">
            <div class="section-title">
              <p className="p">
                Everything You Need In Best Affordable cPanel Hosting Services
              </p>
              <p>
                <span>
                  Select the ideal cPanel hosting plan for you and set up your
                  business with the award-winning web hosting company of India.
                </span>
              </p>
              {/* Location-based pricing info */}
              {userLocation && (
                <div className="pricing-location-info" style={{
                  backgroundColor: '#e6f9fa',
                  padding: '12px 20px',
                  borderRadius: '8px',
                  marginTop: '20px',
                  border: '1px solid #b3ecef',
                  textAlign: 'center'
                }}>
                  <p style={{ 
                    color: '#21bcc3', 
                    fontSize: '14px', 
                    margin: '0',
                    fontWeight: '500'
                  }}>
                    <i className="fa fa-map-marker" style={{ marginRight: '8px' }}></i> 
                    Pricing shown in {userCurrency} for {userLocation.country}
                  </p>
                </div>
              )}
            </div>

            <div class="row tabingcustome">
              <div class="col-12">
                <ul
                  class="nav nav-pills mb-3 justify-content-center"
                  id="pills-tab"
                  role="tablist"
                >
                  <li class="nav-item" role="presentation">
                    <button
                      class="nav-link active first-button"
                      id="pills-inr-tab"
                      data-bs-toggle="pill"
                      data-bs-target="#pills-inr"
                      type="button"
                      role="tab"
                      aria-controls="pills-inr"
                      aria-selected="true"
                    >
                      Monthly
                    </button>
                  </li>
                  <li class="nav-item" role="presentation">
                    <button
                      class="nav-link last-button"
                      id="pills-usd-tab"
                      data-bs-toggle="pill"
                      data-bs-target="#pills-usd"
                      type="button"
                      role="tab"
                      aria-controls="pills-usd"
                      aria-selected="false"
                    >
                      Yearly
                    </button>
                  </li>
                </ul>
              </div>
            </div>

            <div class="tab-content" id="pills-tabContent">
              <div
                class="tab-pane fade show active"
                id="pills-inr"
                role="tabpanel"
                aria-labelledby="pills-inr-tab"
              >
                <div class="row">
                  {Object.entries(cpanelPlans).map(([key, plan]) => (
                    <div key={key} className="col-md-4" data-aos-delay="100">
                      <div className={`box sharedbox ${plan.popular ? 'featured' : ''}`}>
                        <div className="pricing-head">
                          {plan.popular && <span className="advanced">Featured</span>}
                          <p>{plan.name}</p>
                          <p className="subprichead">{plan.subtitle}</p>

                          <h4 style={{
                            background: 'linear-gradient(135deg, #21bcc3 0%, #17a2b8 100%)',
                            color: '#fff',
                            padding: '15px 20px',
                            borderRadius: '8px',
                            textAlign: 'center',
                            margin: '15px 0',
                            fontSize: '24px',
                            fontWeight: '600',
                            border: 'none',
                            boxShadow: '0 4px 15px rgba(33, 188, 195, 0.3)'
                          }}>
                            <CurrencyConverter 
                              priceINR={plan.basePrice} 
                            />
                            <span style={{ fontSize: '16px', opacity: '0.9' }}> / month</span>
                          </h4>

                          <div className="btn-wrap mt-3">
                            <a
                              href={`http://my.clubhosty.com/cart.php?a=add&pid=${plan.pid}&billingcycle=monthly`}
                              className="btn-buy"
                            >
                              Buy Now
                            </a>
                          </div>
                        </div>
                        <ul>
                          {plan.features.map((feature, index) => {
                            const getFeatureIcon = () => {
                              if (feature.includes('Website')) return <FaGlobe />;
                              if (feature.includes('SSD')) return <BsDeviceSsdFill />;
                              if (feature.includes('Bandwidth') || feature.includes('SSL')) return <FaWifi />;
                              if (feature.includes('Theme') || feature.includes('Pro')) return <FaThemeco />;
                              if (feature.includes('Domain')) return <GrDomain />;
                              if (feature.includes('Email')) return <MdEmail />;
                              if (feature.includes('Support')) return <BiSupport />;
                              return <FaGlobe />;
                            };
                            
                            const getFeatureText = () => {
                              if (feature.includes('Free') && (feature.includes('Theme') || feature.includes('Pro') || feature.includes('SSL'))) {
                                return <><b style={{ color: "red" }}>Free</b> {feature.replace('Free ', '')}</>;
                              }
                              if (feature.includes('1 Free Domain')) {
                                return <><b>1 Free</b> Domain</>;
                              }
                              // Bold the important parts
                              if (feature.includes('Host')) {
                                const parts = feature.split(' ');
                                return <><b>{parts.slice(0, 2).join(' ')}</b> {parts.slice(2).join(' ')}</>;
                              }
                              if (feature.includes('GB') || feature.includes('Unlimited')) {
                                const parts = feature.split(' ');
                                return <><b>{parts[0]}</b> {parts.slice(1).join(' ')}</>;
                              }
                              return <b>{feature}</b>;
                            };
                              
                            return (
                              <li key={index}>
                                <span>{getFeatureIcon()}</span>
                                {getFeatureText()}
                              </li>
                            );
                          })}
                        </ul>
                      </div>
                    </div>
                  ))}
                </div>{" "}
              </div>
              <div
                class="tab-pane fade"
                id="pills-usd"
                role="tabpanel"
                aria-labelledby="pills-usd-tab"
              >
                <div class="row">
                  {Object.entries(cpanelPlans).map(([key, plan]) => (
                    <div key={key} className="col-md-4" data-aos-delay="100">
                      <div className={`box sharedbox ${plan.popular ? 'featured' : ''}`}>
                        <div className="pricing-head">
                          {plan.popular && <span className="advanced">Featured</span>}
                          <p>{plan.name}</p>
                          <p className="subprichead">{plan.subtitle}</p>

                          <h4 style={{
                            background: 'linear-gradient(135deg, #21bcc3 0%, #17a2b8 100%)',
                            color: '#fff',
                            padding: '15px 20px',
                            borderRadius: '8px',
                            textAlign: 'center',
                            margin: '15px 0',
                            fontSize: '24px',
                            fontWeight: '600',
                            border: 'none',
                            boxShadow: '0 4px 15px rgba(33, 188, 195, 0.3)'
                          }}>
                            <CurrencyConverter 
                              priceINR={plan.yearlyPrice} 
                            />
                            <span style={{ fontSize: '16px', opacity: '0.9' }}> / year</span>
                          </h4>

                          <div className="btn-wrap mt-3">
                            <a
                              href={`http://my.clubhosty.com/cart.php?a=add&pid=${plan.pid}&billingcycle=annually`}
                              className="btn-buy"
                            >
                              Buy Now
                            </a>
                          </div>
                        </div>
                        <ul>
                          {plan.features.map((feature, index) => {
                            const getFeatureIcon = () => {
                              if (feature.includes('Website')) return <FaGlobe />;
                              if (feature.includes('SSD')) return <BsDeviceSsdFill />;
                              if (feature.includes('Bandwidth') || feature.includes('SSL')) return <FaWifi />;
                              if (feature.includes('Theme') || feature.includes('Pro')) return <FaThemeco />;
                              if (feature.includes('Domain')) return <GrDomain />;
                              if (feature.includes('Email')) return <MdEmail />;
                              if (feature.includes('Support')) return <BiSupport />;
                              return <FaGlobe />;
                            };
                            
                            const getFeatureText = () => {
                              if (feature.includes('Free') && (feature.includes('Theme') || feature.includes('Pro') || feature.includes('SSL'))) {
                                return <><b style={{ color: "red" }}>Free</b> {feature.replace('Free ', '')}</>;
                              }
                              if (feature.includes('1 Free Domain')) {
                                return <><b>1 Free</b> Domain</>;
                              }
                              // Bold the important parts
                              if (feature.includes('Host')) {
                                const parts = feature.split(' ');
                                return <><b>{parts.slice(0, 2).join(' ')}</b> {parts.slice(2).join(' ')}</>;
                              }
                              if (feature.includes('GB') || feature.includes('Unlimited')) {
                                const parts = feature.split(' ');
                                return <><b>{parts[0]}</b> {parts.slice(1).join(' ')}</>;
                              }
                              return <b>{feature}</b>;
                            };
                              
                            return (
                              <li key={index}>
                                <span>{getFeatureIcon()}</span>
                                {getFeatureText()}
                              </li>
                            );
                          })}
                        </ul>
                      </div>
                    </div>
                  ))}
                </div>{" "}
              </div>
            </div>
          </div>
        </section>
        {/* End Pricing Section  */}
        <CPanelComp />

        {/* ======= Shared Benifits =======  */}
        <section class="hostbeni">
          <div class="container">
            <div class="row">
              <div class="col-md-12">
                <div>
                  <h2>Unlimited flexibility for your WordPress website</h2>
                  <p>
                    You may rely on us to provide the correct combination of
                    knowledge and expertise required for excellent WordPress
                    sites. And then launch your website, complete with all of
                    the features you require as well as quick, dependable
                    hosting. Use hosting infrastructure that is both quick and
                    safe to communicate your concept to the rest of the globe.
                    With features that make your project faster, safer, and more
                    trackable, you'll be well on your way to success. We don't
                    make environmental sacrifices in order to provide ClubHosty
                    WordPress hosting.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* End Shared Bentfits  */}

        {/* ======= Services Section =======  */}
        <section id="services" class="services">
          <div class="container">
            <div class="section-title">
              <h2>Services</h2>
              <h3>
                Experience The <span>ClubHosty</span> Difference
              </h3>
            </div>

            <div class="row">
              <div class="col-md-3" data-aos-delay="100">
                <div class="icon-box shbx">
                  <div class="icon">
                    <i class="bx bxl-dribbble"></i>
                  </div>
                  <h4>
                    <Link to="">Auto-Setup</Link>
                  </h4>
                  <p>
                    Don't worry about WordPress install files. WordPress is
                    pre-installed for you!
                  </p>
                </div>
              </div>

              <div class="col-md-3" data-aos-delay="200">
                <div class="icon-box shbx">
                  <div class="icon">
                    <i class="bx bx-file"></i>
                  </div>
                  <h4>
                    <Link to="">Up To 20X Faster</Link>
                  </h4>
                  <p>
                    Host your site on our Turbo Servers for the fastest
                    WordPress Hosting!
                  </p>
                </div>
              </div>

              <div class="col-md-3" data-aos-delay="300">
                <div class="icon-box shbx">
                  <div class="icon">
                    <i class="bx bx-tachometer"></i>
                  </div>
                  <h4>
                    <Link to="">Free SSL Certificate</Link>
                  </h4>
                  <p>
                    Keep your site secure with a free SSL Certificate
                    pre-configured for your site
                  </p>
                </div>
              </div>

              <div class="col-md-3" data-aos-delay="100">
                <div class="icon-box shbx">
                  <div class="icon">
                    <i class="bx bx-world"></i>
                  </div>
                  <h4>
                    <Link to="">Global Servers</Link>
                  </h4>
                  <p>
                    With global data centres, you can keep your website as close
                    to your visitors as possible.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* End Services Section  */}

        {/* ======= Featured Services Section =======  */}

        <section
          id="featured-services"
          class="featured-services section-bg"
          style={{ padding: "60px 0px" }}
        >
          <div class="container">
            <div class="section-title" style={{ textAlign: "center", marginBottom: "4px" }}>
              <h2>Why Choose ClubHosty?</h2>
              <p><strong>EXPERIENCE CPANEL HOSTING WITH POWERFUL FEATURES</strong></p>
              <p style={{ textAlign: 'center' }}>Our cPanel hosting comes with all the tools you need to manage your websites effectively.</p>
            </div>
            <div class="row g-4">
              <div class="col-lg-4 col-md-6">
                <div class="icon-box" style={{ 
                  backgroundColor: "#fff", 
                  borderRadius: "10px", 
                  padding: "30px 25px", 
                  height: "100%", 
                  boxShadow: "0 5px 15px rgba(0,0,0,0.05)", 
                  transition: "0.3s", 
                  border: "1px solid #e9ecef", 
                  cursor: "pointer",
                  transform: "translateY(0px)"
                }}>
                  <div class="icon" style={{ 
                    width: "70px", 
                    height: "70px", 
                    borderRadius: "50%", 
                    display: "flex", 
                    alignItems: "center", 
                    justifyContent: "center", 
                    margin: "0 auto 20px", 
                    backgroundColor: "rgba(33, 162, 160, 0.1)", 
                    color: "#21a2a0", 
                    fontSize: "28px" 
                  }}>
                    <img
                      src="https://res.cloudinary.com/clubhosty/image/upload/v1713838251/data-center-choice_pflxb8.png"
                      alt="Data Center Choice"
                      style={{ width: "35px", height: "35px" }}
                    />
                  </div>
                  <h4 class="title" style={{ 
                    fontSize: "20px", 
                    fontWeight: "600", 
                    marginBottom: "-2px", 
                    textAlign: "center", 
                    color: "#2c3e50" 
                  }}>
                    <Link to="/">Data Center Choice</Link>
                  </h4>
                  <p class="description" style={{ 
                    color: "#666", 
                    textAlign: "center", 
                    margin: "0", 
                    lineHeight: "1.6" 
                  }}>
                    Our Linux cPanel hosting is available in 3 data center locations globally. This includes India, the USA and Singapore.
                  </p>
                </div>
              </div>

              <div class="col-lg-4 col-md-6">
                <div class="icon-box" style={{ 
                  backgroundColor: "#fff", 
                  borderRadius: "10px", 
                  padding: "30px 25px", 
                  height: "100%", 
                  boxShadow: "0 5px 15px rgba(0,0,0,0.05)", 
                  transition: "0.3s", 
                  border: "1px solid #e9ecef", 
                  cursor: "pointer",
                  transform: "translateY(0px)"
                }}>
                  <div class="icon" style={{ 
                    width: "70px", 
                    height: "70px", 
                    borderRadius: "50%", 
                    display: "flex", 
                    alignItems: "center", 
                    justifyContent: "center", 
                    margin: "0 auto 20px", 
                    backgroundColor: "rgba(33, 162, 160, 0.1)", 
                    color: "#21a2a0", 
                    fontSize: "28px" 
                  }}>
                    <img
                      src="https://res.cloudinary.com/clubhosty/image/upload/v1713838297/website-backups-1_avrj5e.png"
                      alt="Website Backups"
                      style={{ width: "35px", height: "35px" }}
                    />
                  </div>
                  <h4 class="title" style={{ 
                    fontSize: "20px", 
                    fontWeight: "600", 
                    marginBottom: "-2px", 
                    textAlign: "center", 
                    color: "#2c3e50" 
                  }}>
                    <Link to="/">Free Daily Backup</Link>
                  </h4>
                  <p class="description" style={{ 
                    color: "#666", 
                    textAlign: "center", 
                    margin: "0", 
                    lineHeight: "1.6" 
                  }}>
                    We include website backups as a standard with our cPanel hosting plans. When others charge for this, we don't!
                  </p>
                </div>
              </div>

              <div class="col-lg-4 col-md-6">
                <div class="icon-box" style={{ 
                  backgroundColor: "#fff", 
                  borderRadius: "10px", 
                  padding: "30px 25px", 
                  height: "100%", 
                  boxShadow: "0 5px 15px rgba(0,0,0,0.05)", 
                  transition: "0.3s", 
                  border: "1px solid #e9ecef", 
                  cursor: "pointer",
                  transform: "translateY(0px)"
                }}>
                  <div class="icon" style={{ 
                    width: "70px", 
                    height: "70px", 
                    borderRadius: "50%", 
                    display: "flex", 
                    alignItems: "center", 
                    justifyContent: "center", 
                    margin: "0 auto 20px", 
                    backgroundColor: "rgba(33, 162, 160, 0.1)", 
                    color: "#21a2a0", 
                    fontSize: "28px" 
                  }}>
                    <img
                      src="https://res.cloudinary.com/clubhosty/image/upload/v1713838379/newest-php_bjaet7.png"
                      alt="Newest PHP & SQL"
                      style={{ width: "35px", height: "35px" }}
                    />
                  </div>
                  <h4 class="title" style={{ 
                    fontSize: "20px", 
                    fontWeight: "600", 
                    marginBottom: "-2px", 
                    textAlign: "center", 
                    color: "#2c3e50" 
                  }}>
                    <Link to="/">Newest PHP & SQL</Link>
                  </h4>
                  <p class="description" style={{ 
                    color: "#666", 
                    textAlign: "center", 
                    margin: "0", 
                    lineHeight: "1.6" 
                  }}>
                    We support PHP versions ranging from 5.6 to 8.4. All the latest and stable versions of PHP & MySQL databases are installed.
                  </p>
                </div>
              </div>

              <div class="col-lg-4 col-md-6">
                <div class="icon-box" style={{ 
                  backgroundColor: "#fff", 
                  borderRadius: "10px", 
                  padding: "30px 25px", 
                  height: "100%", 
                  boxShadow: "0 5px 15px rgba(0,0,0,0.05)", 
                  transition: "0.3s", 
                  border: "1px solid #e9ecef", 
                  cursor: "pointer",
                  transform: "translateY(0px)"
                }}>
                  <div class="icon" style={{ 
                    width: "70px", 
                    height: "70px", 
                    borderRadius: "50%", 
                    display: "flex", 
                    alignItems: "center", 
                    justifyContent: "center", 
                    margin: "0 auto 20px", 
                    backgroundColor: "rgba(33, 162, 160, 0.1)", 
                    color: "#21a2a0", 
                    fontSize: "28px" 
                  }}>
                    <img
                      src="https://res.cloudinary.com/clubhosty/image/upload/v1713838452/free-domain_p6kvpp.png"
                      alt="Free Domain & SSL"
                      style={{ width: "35px", height: "35px" }}
                    />
                  </div>
                  <h4 class="title" style={{ 
                    fontSize: "20px", 
                    fontWeight: "600", 
                    marginBottom: "-2px", 
                    textAlign: "center", 
                    color: "#2c3e50" 
                  }}>
                    <Link to="/">Free SSL Certificate</Link>
                  </h4>
                  <p class="description" style={{ 
                    color: "#666", 
                    textAlign: "center", 
                    margin: "0", 
                    lineHeight: "1.6" 
                  }}>
                    All of our cPanel hosting plans come with unlimited Free SSL certificates by Let's Encrypt to keep your data secure.
                  </p>
                </div>
              </div>

              <div class="col-lg-4 col-md-6">
                <div class="icon-box" style={{ 
                  backgroundColor: "#fff", 
                  borderRadius: "10px", 
                  padding: "30px 25px", 
                  height: "100%", 
                  boxShadow: "0 5px 15px rgba(0,0,0,0.05)", 
                  transition: "0.3s", 
                  border: "1px solid #e9ecef", 
                  cursor: "pointer",
                  transform: "translateY(0px)"
                }}>
                  <div class="icon" style={{ 
                    width: "70px", 
                    height: "70px", 
                    borderRadius: "50%", 
                    display: "flex", 
                    alignItems: "center", 
                    justifyContent: "center", 
                    margin: "0 auto 20px", 
                    backgroundColor: "rgba(33, 162, 160, 0.1)", 
                    color: "#21a2a0", 
                    fontSize: "28px" 
                  }}>
                    <img
                      src="https://res.cloudinary.com/clubhosty/image/upload/v1713838515/ssd-storage_warycp.png"
                      alt="SSD Storage"
                      style={{ width: "35px", height: "35px" }}
                    />
                  </div>
                  <h4 class="title" style={{ 
                    fontSize: "20px", 
                    fontWeight: "600", 
                    marginBottom: "-2px", 
                    textAlign: "center", 
                    color: "#2c3e50" 
                  }}>
                    <Link to="/">NVME SSD Storage</Link>
                  </h4>
                  <p class="description" style={{ 
                    color: "#666", 
                    textAlign: "center", 
                    margin: "0", 
                    lineHeight: "1.6" 
                  }}>
                    NVME SSD(s) are 20X faster than a normal HDD & helps make sure much more fast!
                  </p>
                </div>
              </div>

              <div class="col-lg-4 col-md-6">
                <div class="icon-box" style={{ 
                  backgroundColor: "#fff", 
                  borderRadius: "10px", 
                  padding: "30px 25px", 
                  height: "100%", 
                  boxShadow: "0 5px 15px rgba(0,0,0,0.05)", 
                  transition: "0.3s", 
                  border: "1px solid #e9ecef", 
                  cursor: "pointer",
                  transform: "translateY(0px)"
                }}>
                  <div class="icon" style={{ 
                    width: "70px", 
                    height: "70px", 
                    borderRadius: "50%", 
                    display: "flex", 
                    alignItems: "center", 
                    justifyContent: "center", 
                    margin: "0 auto 20px", 
                    backgroundColor: "rgba(33, 162, 160, 0.1)", 
                    color: "#21a2a0", 
                    fontSize: "28px" 
                  }}>
                    <img
                      src="https://res.cloudinary.com/clubhosty/image/upload/v1713838592/uptime-guarantee_vldyqj.png"
                      alt="Uptime Guarantee"
                      style={{ width: "35px", height: "35px" }}
                    />
                  </div>
                  <h4 class="title" style={{ 
                    fontSize: "20px", 
                    fontWeight: "600", 
                    marginBottom: "-2px", 
                    textAlign: "center", 
                    color: "#2c3e50" 
                  }}>
                    <Link to="/">99.95% Uptime Guarantee</Link>
                  </h4>
                  <p class="description" style={{ 
                    color: "#666", 
                    textAlign: "center", 
                    margin: "0", 
                    lineHeight: "1.6" 
                  }}>
                    With a 99.95% uptime guarantee, be assured your website is online, available and operational.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* End Featured Services Section  */}

        {/* ======= WordPress Transfer Section =======  */}
        <section 
          id="wordpress-transfer" 
          className="wordpress-transfer-section section-bg" 
          style={{ 
            backgroundColor: "#ffffffff", 
            padding: "80px 0",
            position: "relative",
            overflow: "hidden"
          }}
        >
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-6" data-aos-delay="100">
                <div style={{ 
                  backgroundColor: "#fff", 
                  borderRadius: "20px",
                  padding: "40px",
                  boxShadow: "0 10px 30px rgba(33, 188, 195, 0.1)",
                  position: "relative",
                  height: "100%"
                }}>
                  <img
                    src="https://res.cloudinary.com/clubhosty/image/upload/v1713848247/wordpress-transfer_tuk4z0.png"
                    alt="WordPress Site Transfer"
                    style={{ 
                      width: "100%",
                      maxWidth: "100%",
                      height: "auto",
                      borderRadius: "15px",
                      filter: "hue-rotate(317deg) saturate(1.2)"
                    }}
                  />
                </div>
              </div>
              
              <div className="col-lg-6" data-aos-delay="200">
                <div style={{ 
                  backgroundColor: "#fff", 
                  borderRadius: "20px",
                  padding: "40px",
                  boxShadow: "0 10px 30px rgba(33, 188, 195, 0.1)",
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center"
                }}>
                  <h2 style={{ 
                    color: "#333", 
                    fontSize: "36px", 
                    fontWeight: "600", 
                    lineHeight: "1.2", 
                    marginBottom: "20px",
                    fontFamily: "'Poppins', sans-serif"
                  }}>
                    Free website migration, fully managed by Us
                  </h2>
                  
                  <p style={{ 
                    color: "#666", 
                    fontSize: "16px", 
                    lineHeight: "1.6", 
                    marginBottom: "30px",
                    fontFamily: "'Poppins', sans-serif",
                    fontWeight: "500"
                  }}>
                    Our experts handle the technical aspects of moving your website, with data security at the utmost priority. So sit back and enjoy a stress-free transition to our platform without any additional costs.
                  </p>
                  
                  <button 
                    onClick={() => {
                      const pricingSection = document.getElementById('pricing');
                      if (pricingSection) {
                        pricingSection.scrollIntoView({ behavior: 'smooth' });
                      }
                    }}
                    style={{ 
                      background: "#21bcc3",
                      border: "none",
                      color: "#fff",
                      padding: "15px 30px",
                      fontSize: "16px",
                      fontWeight: "600",
                      borderRadius: "8px",
                      cursor: "pointer",
                      boxShadow: "0 4px 15px rgba(33, 188, 195, 0.3)",
                      transition: "all 0.3s ease",
                      fontFamily: "'Poppins', sans-serif",
                      alignSelf: "flex-start"
                    }}>
                    Migrate now
                  </button>
                </div>
              </div>
            </div>
          </div>
          
          <style jsx>{`
            .wordpress-transfer-section button:hover {
              transform: translateY(-2px);
              background: #20bfc0;
              box-shadow: 0 6px 20px rgba(33, 188, 195, 0.4);
            }
          `}</style>
        </section>
        {/* End About Section  */}

        {/* ======= Featured Services Section =======  */}
        {/* <section id="featured-services" class="featured-services">
          <div class="container">
            <div class="row">
              <div class="col-md-4">
                <div class="icon-box" data-aos-delay="100">
                  <div class="icon">
                    <i class="fa fa-desktop"></i>
                  </div>
                  <h4 class="title">
                    <Link to="">Cpanel</Link>
                  </h4>
                  <p class="description">
                    World's no 1 hosting control panel with nice user interface.
                    Cron schedulling , seo tools, customize php versions.
                  </p>
                </div>
              </div>

              <div class="col-md-4">
                <div class="icon-box" data-aos-delay="200">
                  <div class="icon">
                    <i class="fa fa-hdd-o"></i>
                  </div>
                  <h4 class="title">
                    <Link to="">NVME SSD</Link>
                  </h4>
                  <p class="description">
                    SSD (Solid state drives) and HDD (Hard disk drive) both
                    functionally same but SSD Drives 20x Faster.
                  </p>
                </div>
              </div>

              <div class="col-md-4">
                <div class="icon-box" data-aos-delay="300">
                  <div class="icon">
                    <i class="fa fa-refresh"></i>
                  </div>
                  <h4 class="title">
                    <Link to="">Secure Backups</Link>
                  </h4>
                  <p class="description">
                    Never lose your website’s data while you host your website
                    at our server Free Of Cost.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section> */}

        {/* End Featured Services Section  */}

        {/* FAQ Start */}
        <section id="about" className="about">
          <div className="section-title">
            <h2>Frequently Asked Questions</h2>
            {/* <p style={{ padding: "10px" }}>
						You ask, we answer! Here are the most asked questions for our Domain
						Registration service!
					</p> */}
            <Divider />
          </div>
          <div className="accordionContainer">
            <Accordion allowZeroExpanded>
              <AccordionItem>
                <AccordionItemHeading>
                  <AccordionItemButton>What is cPanel?</AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <p>
                    cPanel is basically an industry-leading and user-friendly
                    web hosting control panel. It lets you manage your websites
                    and entire web hosting account with ease. Further, with
                    cPanel, you can configure your files, databases, email
                    accounts, SSL certificates and more. Simplify all your
                    hosting account management in one place.
                  </p>
                </AccordionItemPanel>
              </AccordionItem>
              <AccordionItem>
                <AccordionItemHeading>
                  <AccordionItemButton>
                    What is cPanel hosting?
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <p>
                    cPanel hosting is a kind of hosting service wherein you get
                    a cPanel as a control panel. This way, your hosting account
                    management is completely a breeze. Each of the websites
                    shares the resources (disk space, data transfer, CPU, memory
                    etc.) available on that dedicated cPanel server.
                  </p>
                </AccordionItemPanel>
              </AccordionItem>
              <AccordionItem>
                <AccordionItemHeading>
                  <AccordionItemButton>
                    What are the advantages of cPanel hosting?
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <p>
                    The first advantage of cPanel web hosting is its cost. Given
                    that a number of websites share the server resources, the
                    cost of maintenance is shared between the number of users.
                    This brings the end user cost down considerably. Another
                    advantage is that as the web host, we are responsible for
                    managing the server. Technical support is available 24x7, if
                    there are any issues with your website you can contact our
                    team and get the issue fixed.
                  </p>
                </AccordionItemPanel>
              </AccordionItem>
              <AccordionItem>
                <AccordionItemHeading>
                  <AccordionItemButton>
                    Is customer support included with cPanel web Hosting?
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <p>
                    When you purchase one of our cheap cPanel hosting, it means
                    you're covered by a customer support team 24/7. Whenever you
                    face any technical issues, our qualified professionals will
                    get back with the right solution.
                  </p>
                </AccordionItemPanel>
              </AccordionItem>
              <AccordionItem>
                <AccordionItemHeading>
                  <AccordionItemButton>
                    Do you provide website backups?
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <p>
                    Yes, ClubHosty cheap cPanel hosting plan gives you complete
                    peace of mind knowing that your website data is 100% secure.
                    We offer daily website backups at no additional cost. If
                    something goes wrong, you can restore the data and have it
                    back online, not disrupt your business.
                  </p>
                </AccordionItemPanel>
              </AccordionItem>
              <AccordionItem>
                <AccordionItemHeading>
                  <AccordionItemButton>
                    Does cPanel support any CMS other than WordPress?
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <p>
                    Yes, cPanel is a versatile control panel in that case. You
                    can install any of the Content Management Systems on cPanel.
                    ClubHosty supports more than WordPress hosting. You can host
                    any website based on a Content Management System such as
                    WordPress, Drupal, Laravel and more.
                  </p>
                </AccordionItemPanel>
              </AccordionItem>
            </Accordion>
          </div>
        </section>
        {/* FAQ End */}
      </main>
      {/* End #main  */}
    </>
  );
}

export default CpanelHosting;
